// extracted by mini-css-extract-plugin
module.exports = {"column":"repay-column_column__2ZZ4G","buttonWrapper":"repay-column_buttonWrapper__2y8Jb"};